import renderAutoSuggestWithOptions from './AutoSuggestHOC';
import { hiringCompanyJobfeedForPartnerAutoCompleteInput$, hiringCompanyJobfeedForPartnerAutoCompleteObservable$ } from '../../redux/autosuggest/autoCompleteService';

const HiringCompanyJobfeedForPartnerAutoSuggest = renderAutoSuggestWithOptions(
   hiringCompanyJobfeedForPartnerAutoCompleteObservable$,
   hiringCompanyJobfeedForPartnerAutoCompleteInput$,
);

HiringCompanyJobfeedForPartnerAutoSuggest.defaultProps = {
   selected: {
      id: null,
      name: '',
   },
   filterOrganization: [],
   forceSelection: false,
   placeholder: 'Search Hiring Company...',
};

export default HiringCompanyJobfeedForPartnerAutoSuggest;
